export enum ENotificationTaskModel{
  conversation = "Conversation",
  message = "Message"  
}